import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { datiBilancioCkHelper, getDatiBilancioControl, getDatiBilancioGroup } from './helpers/dati-bilancio-form.helpers';
import { toNum } from '@shared/helpers/math.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { addRemoveError, getControl, getGroup } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isEqual } from 'lodash-es';

export const datiBilancioPrestitoSociRules: FormGroupRules = {
    my_CkPrestitoSociCorretto: (form: FormGroup) => {
        datiBilancioCkHelper(form, 'my_CkPrestitoSociCorretto', 'my_CkPrestitoSoci', 1);
    },

    my_CkIndiceIndebit: (form: FormGroup) => {
        const my_NumSociDataDich = toNum(getDatiBilancioControl(form, 'my_SchedaVerificaPrestito.my_NumSociDataDich')?.value);
        datiBilancioCkHelper(form, 'my_CkIndiceIndebit', 'my_CkPrestitoSoci', 1, formPaths.bilancio, my_NumSociDataDich > 50);
    },

    my_CkRipettatoCICR: (form: FormGroup) => {
        const my_NumSociDataDich = toNum(getDatiBilancioControl(form, 'my_SchedaVerificaPrestito.my_NumSociDataDich')?.value);
        datiBilancioCkHelper(form, 'my_SchedaVerificaPrestito.my_CkRipettatoCICR', 'my_CkPrestitoSoci', 1, formPaths.bilancio, my_NumSociDataDich > 50);
    },

    my_PatrNettoUltBil: (form: FormGroup) => {
        const my_PatrNettoUltBilControl = getDatiBilancioControl(form, 'my_SchedaVerificaPrestito.my_PatrNettoUltBil');
        const my_PatrNettoUltBil: string = my_PatrNettoUltBilControl?.value;
        const my_PatrimonioBil: string = getDatiBilancioControl(form, 'my_SchedaVerificaPrestito.my_PatrimonioBil')?.value;
        const my_CkPrestitoSoci: string = getDatiBilancioControl(form, 'my_CkPrestitoSoci')?.value;
        const my_NumSociDataDich = toNum(getDatiBilancioControl(form, 'my_SchedaVerificaPrestito.my_NumSociDataDich')?.value);
        const my_PartecPiuDi50InSpa: string = getControl(form, 'my_PartecPiuDi50InSpa')?.value;
        const my_CkRedazBilConsol: string = getDatiBilancioControl(form, 'my_CkRedazBilConsol')?.value;
        const errors = my_PatrNettoUltBilControl.errors ? my_PatrNettoUltBilControl.errors : {};
        const conditionCampoObbligatorio = isNilOrEmpty(my_PatrNettoUltBil) && my_CkPrestitoSoci === '1' && my_NumSociDataDich > 50;
        const conditionVerificareObbligoRedigereBilancio = my_PatrNettoUltBil === my_PatrimonioBil && my_CkPrestitoSoci === '1' && my_PartecPiuDi50InSpa === '1';
        const conditionObbligoRedigereBilancio = my_PatrNettoUltBil === my_PatrimonioBil && my_CkPrestitoSoci === '1' && my_CkRedazBilConsol === '1';

        addRemoveError(conditionCampoObbligatorio, errors, 'my_PatrNettoUltBil', {
            status: REQUIRED_STATUS,
        });

        addRemoveError(conditionVerificareObbligoRedigereBilancio, errors, 'my_PatrNettoUltBil_verificaObbligo', {
            status: "Verificare se la cooperativa ha l'obbligo di redigere il bilancio consolidato",
        });

        addRemoveError(conditionObbligoRedigereBilancio, errors, 'my_PatrNettoUltBil_obbligo', {
            status: "La cooperativa ha l'obbligo di redigere il bilancio consolidato, verificare il patrimonio netto inserito",
        });

        my_PatrNettoUltBilControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkRispettatoLimiteIndivid: (form: FormGroup) => {
        datiBilancioCkHelper(form, 'my_SchedaVerificaPrestito.my_CkRispettatoLimiteIndivid', 'my_CkPrestitoSoci', 1);
    },

    my_NSociPrestitoPF: (form: FormGroup) => {
        nSociHelper(
            form,
            'my_NSociPrestitoPF',
            'my_PrestSociFruttPF',
            'my_PrestSociInfruttPF',
            'In presenza di prestito sociale per le persone fisiche inserire il numero di soci'
        );
    },

    my_NSociPrestitoPG: (form: FormGroup) => {
        nSociHelper(
            form,
            'my_NSociPrestitoPG',
            'my_PrestSociFruttPG',
            'my_PrestSociInfruttPG',
            'In presenza di prestito sociale per le persone giuridiche inserire il numero di soci'
        );
    },

    my_PrestSociFruttPG: (form: FormGroup) => {
        datiBilancioCkHelper(form, 'my_SchedaVerificaPrestito.my_PrestSociFruttPG', 'my_CkPrestitoSoci', 1);
    },

    my_PrestSociInfruttPG: (form: FormGroup) => {
        datiBilancioCkHelper(form, 'my_SchedaVerificaPrestito.my_PrestSociInfruttPG', 'my_CkPrestitoSoci', 1);
    },

    my_PrestSociFruttPF: (form: FormGroup) => {
        datiBilancioCkHelper(form, 'my_SchedaVerificaPrestito.my_PrestSociFruttPF', 'my_CkPrestitoSoci', 1);
    },

    my_PrestSociInfruttPF: (form: FormGroup) => {
        datiBilancioCkHelper(form, 'my_SchedaVerificaPrestito.my_PrestSociInfruttPF', 'my_CkPrestitoSoci', 1);
    },

    my_PrestitoSociale: (form: FormGroup) => {
        datiBilancioCkHelper(form, 'my_SchedaVerificaPrestito.my_PrestitoSociale', 'my_CkPrestitoSoci', 1);
    },

    my_lblImportoPrestito: (form: FormGroup) => {
        const schedaVerificaPrestitoGroup = getGroup(getDatiBilancioGroup(form), 'my_SchedaVerificaPrestito');
        const my_lblImportoPrestitoControl = getControl(schedaVerificaPrestitoGroup, 'my_lblImportoPrestito');
        const my_PrestSociFruttPFRaw: string = getControl(schedaVerificaPrestitoGroup, 'my_PrestSociFruttPF')?.value;
        const my_PrestSociFruttPGRaw: string = getControl(schedaVerificaPrestitoGroup, 'my_PrestSociFruttPG')?.value;
        const my_PrestSociInfruttPFRaw: string = getControl(schedaVerificaPrestitoGroup, 'my_PrestSociInfruttPF')?.value;
        const my_PrestSociInfruttPGRaw: string = getControl(schedaVerificaPrestitoGroup, 'my_PrestSociInfruttPG')?.value;
        const my_PrestSociFruttPF = toNum(my_PrestSociFruttPFRaw);
        const my_PrestSociFruttPG = toNum(my_PrestSociFruttPGRaw);
        const my_PrestSociInfruttPF = toNum(my_PrestSociInfruttPFRaw);
        const my_PrestSociInfruttPG = toNum(my_PrestSociInfruttPGRaw);
        const my_PrestitoSociale = toNum(getControl(schedaVerificaPrestitoGroup, 'my_PrestitoSociale')?.value);
        const errors = my_lblImportoPrestitoControl?.errors ? my_lblImportoPrestitoControl.errors : {};
        const showError =
            !isNilOrEmpty(my_PrestSociFruttPFRaw) &&
            !isNilOrEmpty(my_PrestSociFruttPGRaw) &&
            !isNilOrEmpty(my_PrestSociInfruttPFRaw) &&
            !isNilOrEmpty(my_PrestSociInfruttPGRaw) &&
            Math.floor(my_PrestitoSociale) != Math.floor(my_PrestSociFruttPF + my_PrestSociFruttPG + my_PrestSociInfruttPF + my_PrestSociInfruttPG);

        addRemoveError(showError, errors, 'my_lblImportoPrestito', {
            status: 'Attenzione: totali non corrispondenti',
            message: "Il totale del prestito non corrisponde alla voce 'prestito sociale alla data della revisione'",
        });

        my_lblImportoPrestitoControl?.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_lblSociPrestito: (form: FormGroup) => {
        const schedaVerificaPrestitoGroup = getGroup(getDatiBilancioGroup(form), 'my_SchedaVerificaPrestito');
        const effetivitaBaseSocialeGroup = getGroup(form, 'my_SezioneI__Rilevazione.my_EffettivitaBaseSociale');
        const my_lblSociPrestitoControl = getControl(schedaVerificaPrestitoGroup, 'my_lblSociPrestito');
        const my_NumSociDataDich = toNum(getControl(schedaVerificaPrestitoGroup, 'my_NumSociDataDich')?.value);
        const my_NSociPrestitoPF = toNum(getControl(schedaVerificaPrestitoGroup, 'my_NSociPrestitoPF')?.value);
        const my_NSociPrestitoPG = toNum(getControl(schedaVerificaPrestitoGroup, 'my_NSociPrestitoPG')?.value);
        const my_CkPrestitoSoci: string = getDatiBilancioControl(form, 'my_CkPrestitoSoci')?.value;
        const my_SociFisCoopData = toNum(getControl(effetivitaBaseSocialeGroup, 'my_SociFisCoopData')?.value);
        const my_SociFisFinData = toNum(getControl(effetivitaBaseSocialeGroup, 'my_SociFisFinData')?.value);
        const my_SociSpecData_personeFisiche = toNum(getControl(effetivitaBaseSocialeGroup, 'my_gr0001.my_SociSpecData_personeFisiche')?.value);
        const my_SociGiuFinData = toNum(getControl(effetivitaBaseSocialeGroup, 'my_SociGiuFinData')?.value);
        const my_SociGiuCoopData = toNum(getControl(effetivitaBaseSocialeGroup, 'my_SociGiuCoopData')?.value);
        const my_SociSpecData = toNum(getControl(effetivitaBaseSocialeGroup, 'my_SociSpecData')?.value);
        const showSociError =
            my_NumSociDataDich < my_NSociPrestitoPF + my_NSociPrestitoPG && !isNilOrEmpty(my_NumSociDataDich) && my_NumSociDataDich > 0 && my_CkPrestitoSoci === '1';
        const showPersoneFisicheError = my_NSociPrestitoPF > my_SociFisCoopData + my_SociFisFinData + my_SociSpecData_personeFisiche && my_CkPrestitoSoci === '1';
        const showPersoneGiuridicheError =
            my_NSociPrestitoPG > my_SociGiuCoopData + my_SociGiuFinData + (my_SociSpecData - my_SociSpecData_personeFisiche) && my_CkPrestitoSoci === '1';
        const errors = my_lblSociPrestitoControl?.errors ? my_lblSociPrestitoControl.errors : {};

        addRemoveError(showSociError, errors, 'my_lblSociPrestito', {
            status: 'Attenzione: verificare il numero di soci inserito',
        });

        addRemoveError(showPersoneFisicheError, errors, 'my_lblSociPrestito_personeFisiche', {
            status: 'Attenzione: verificare il numero di soci persone fisiche inserito',
        });

        addRemoveError(showPersoneGiuridicheError, errors, 'my_lblSociPrestito_personeGiuridiche', {
            status: 'Attenzione: verificare il numero di soci persone giuridiche inserito',
        });

        my_lblSociPrestitoControl?.setErrors(isEqual(errors, {}) ? null : errors);
    },
};

const nSociHelper = (form: FormGroup, targetPath: string, PrestSociFruttPath: string, my_PrestSociInfruttPath: string, status: string) => {
    const schedaVerificaPrestitoGroup = getGroup(getDatiBilancioGroup(form), 'my_SchedaVerificaPrestito');
    const my_NSociPrestitoControl = getControl(schedaVerificaPrestitoGroup, targetPath);
    const my_PrestSociFrutt = toNum(getControl(schedaVerificaPrestitoGroup, PrestSociFruttPath)?.value);
    const my_PrestSociInfrutt = toNum(getControl(schedaVerificaPrestitoGroup, my_PrestSociInfruttPath)?.value);
    const my_CkPrestitoSoci: string = getDatiBilancioControl(form, 'my_CkPrestitoSoci')?.value;
    const errors = my_NSociPrestitoControl.errors ? my_NSociPrestitoControl.errors : {};
    const conditionCampoObbligatorio = isNilOrEmpty(my_NSociPrestitoControl?.value) && my_CkPrestitoSoci === '1';
    const conditionPrestito = toNum(my_NSociPrestitoControl?.value) === 0 && my_PrestSociFrutt + my_PrestSociInfrutt > 0 && my_CkPrestitoSoci === '1';

    addRemoveError(conditionCampoObbligatorio, errors, targetPath, {
        status: REQUIRED_STATUS,
    });

    addRemoveError(conditionPrestito, errors, targetPath, {
        status,
    });

    my_NSociPrestitoControl.setErrors(isEqual(errors, {}) ? null : errors);
};
